@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.blockedusers.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.blockedusers.resources/"

@delegate:ResourceContentHash(-1_568_562_302)
internal val Res.string.blockedusers_empty_message: StringResource by lazy {
      StringResource("string:blockedusers_empty_message", "blockedusers_empty_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 146),
      ))
    }

@delegate:ResourceContentHash(1_977_441_013)
internal val Res.string.blockedusers_empty_title: StringResource by lazy {
      StringResource("string:blockedusers_empty_title", "blockedusers_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157, 60),
      ))
    }

@delegate:ResourceContentHash(-612_399_298)
internal val Res.string.blockedusers_intro: StringResource by lazy {
      StringResource("string:blockedusers_intro", "blockedusers_intro", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218, 182),
      ))
    }

@delegate:ResourceContentHash(-1_345_378_304)
internal val Res.string.blockedusers_title: StringResource by lazy {
      StringResource("string:blockedusers_title", "blockedusers_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 50),
      ))
    }

@delegate:ResourceContentHash(2_065_976_953)
internal val Res.string.blockedusers_unblock: StringResource by lazy {
      StringResource("string:blockedusers_unblock", "blockedusers_unblock", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 452, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("blockedusers_empty_message", Res.string.blockedusers_empty_message)
  map.put("blockedusers_empty_title", Res.string.blockedusers_empty_title)
  map.put("blockedusers_intro", Res.string.blockedusers_intro)
  map.put("blockedusers_title", Res.string.blockedusers_title)
  map.put("blockedusers_unblock", Res.string.blockedusers_unblock)
}
